import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Row, FormControl } from "react-bootstrap";
import { Formik } from 'formik';

import { billingCategories, fees, feeGroups } from '../../ducks';
import { duckify } from "utils/duckify";

import ModalComponent from '../ModalComponent';
import FeeGroupModalErrorWrapper from './FeeGroupModalErrorWrapper';

const FeeTypeDetailsModal = ({
  feeGroupId,
  closeModal,
  billingCategories,
  feesCreate,
  editData,
  feesUpdate
}) => {

  const [formikErrors, setFormikErrors] = useState({});

  const billingGroupsOptions = billingCategories.map((opt) => {
    return <option value={opt.id} key={opt.id}>{opt.name}</option>
  })

  const initialValues = {
    fee_group_id: feeGroupId,
    name: '',
    billing_category_id: ''
  }

  if(editData){
    initialValues.name = editData.name;
    initialValues.billing_category_id = editData.billing_category.id
  }

  const onSubmit = (values) => {

    if(editData){
      values.id = editData.id;
    }

    const dispatchFees = editData ? feesUpdate(values) : feesCreate(values);

    dispatchFees
      .then( ()=> {
        closeModal();
      })
      .catch( (err) => {
        setFormikErrors(err);
      })

  };

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ (values) => onSubmit(values)}
    >
      {({
        values,
        handleChange,
        handleSubmit
      }) => {

        const buttons = [
          <Button type='submit' onClick={handleSubmit}>Submit</Button>
        ]

        return (
          <ModalComponent
          onClose={() => closeModal()}
          className={'fee-group-modal'}
          title={'Fee Type Details'}
          buttons={buttons}
          >
            <form>
              {Object.keys(formikErrors).length > 0 &&
                <FeeGroupModalErrorWrapper>
                  {formikErrors.name && <li><span className="feegroup-error-wrapper-title">Name</span> {formikErrors.name}</li>}
                  {formikErrors.billing_category && <li><span className="feegroup-error-wrapper-title">Billing Category</span> {formikErrors.billing_category}</li>}
                </FeeGroupModalErrorWrapper>
              }
              <Row className={formikErrors.name ? 'error' : null}>
                <label className="col-form-label">
                  Fee Type Name
                </label>
                <div className="controls">
                  <FormControl type={'text'} name={"name"} defaultValue={values.name} onChange={handleChange} />
                </div>
              </Row>
              <Row className={formikErrors.billing_category ? 'error' : null}>
                <label className="col-form-label">
                  Billing Category
                </label>
                <div className="controls">
                  <select value={values.billing_category_id} name={"billing_category_id"} onChange={handleChange} >
                    <option value="" ></option>
                    {billingGroupsOptions}
                  </select>
                </div>
              </Row>
            </form>
          </ModalComponent>
        )

      }}

    </Formik>
  )
};

const mapDucksToProps = () => ({ billingCategories });
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feesCreate: (feesGroupObj) => {
    return dispatch(fees.actions.create(feesGroupObj)).then(() => dispatch(feeGroups.actions.markDirty()))
  },
  feesUpdate: (feesGroupObj) => {
    return dispatch(fees.actions.update(feesGroupObj)).then(() => dispatch(feeGroups.actions.markDirty()))
  }
});

FeeTypeDetailsModal.propTypes = {
  feeGroupId: PropTypes.string,
  billingCategories: PropTypes.array,
  closeModal: PropTypes.func,
  feesCreate: PropTypes.func,
  feesUpdate: PropTypes.func,
  editData: PropTypes.shape({
    billing_category: PropTypes.shape({
      id: PropTypes.string
    }),
    name: PropTypes.string
  })
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeTypeDetailsModal);